import type { ReactNode } from 'react';

export const ProjectPlanEmptyState = ({ children }: { children?: ReactNode }) => (
  <p className="py-4 text-center text-sm font-medium text-gray-700">
    {children ?? 'No responses yet'}
  </p>
);
